import React from 'react';
import { Link } from 'lucide-react';
import { useDocumentParticipants } from '../hooks/useDocumentParticipants';
import { KnowledgeItem } from '../services/api';

interface ParticipantsIndicatorProps {
  knowledgeItemId: string;
  fileType?: string;
  isShared?: boolean;
  knowledgeItem?: KnowledgeItem;
}

export const ParticipantsIndicator: React.FC<ParticipantsIndicatorProps> = ({
  knowledgeItemId,
  fileType,
  isShared = false,
  knowledgeItem
}) => {
  // ИСПОЛЬЗУЕМ ТУ ЖЕ ЛОГИКУ, ЧТО И В DocumentParticipantsModal
  const shouldShow = knowledgeItem?.isShared === true && 
    knowledgeItem?.participants && 
    Array.isArray(knowledgeItem.participants) && 
    knowledgeItem.participants.length > 1;



  // Показываем иконку только если есть больше одного участника
  if (!shouldShow) {
    return null;
  }

  return (
    <div className="flex items-center">
      <Link className="w-3.5 h-3.5 text-blue-500 mr-1" strokeWidth={1.5} />
    </div>
  );
}; 